<template>
  <v-app>
    <hjHeader v-if="isLogged" @openMenu="toggleMenu(true)" />
    <v-navigation-drawer
      v-model="drawer"
      absolute
      clipped
      temporary
      width="350"
    >
      <v-card class="indigo white--text mx-auto rounded-0">
        <v-card-title>
          {{ company }}
        </v-card-title>

        <v-card-text class="white--text">
          <strong>{{ userName }}</strong>
        </v-card-text>
      </v-card>
      <ui-menu-page :drawer="drawer" />
      <template v-slot:append>
        <div class="pa-2 indigo darken-2 text-center white--text">
          <small>
            Jointech Tecnologia em Sistemas
          </small>
        </div>
      </template>
    </v-navigation-drawer>

    <v-main style="100%">
      <router-view />
    </v-main>

    <fhistory />

    <v-dialog v-model="dialog.show" hide-overlay persistent width="400">
      <v-card color="indigo darken-2" dark>
        <v-card-title>
          Existe uma empresa pré selecionada
        </v-card-title>

        <v-card-text>
          A empresa {{ dialog.franchise.franchise }} esta pré selecionada.
          Deseja carregar os dados da mesma?
        </v-card-text>

        <v-card-actions>
          <v-btn @click="dialog.show = false">
            Cancelar
          </v-btn>
          <v-divider />
          <v-btn @click="selectFranchise">
            Aceitar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" :timeout="3000" :color="snackbar.type">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar.show = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { fhistory, uiMenuPage, hjHeader } from "@/components/ui";

export default {
  name: "App",

  components: {
    fhistory,
    uiMenuPage,
    hjHeader,
  },

  data() {
    return {
      drawer: false,
      group: null,
      dialog: {
        show: false,
        franchise: {
          franchise: null,
          id: null,
          date: null,
        },
      },
      snackbar: {
        show: false,
        type: "indigo",
        text: "",
      },
      date: {
        show: false,
        value: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      company: "companyName",
      isLogged: "isLogged",
      userName: "userName",
      userSuper: "userSuper",
      franchiseName: "franchiseName",
      franchiseDate: "franchiseDate",
      franchiseGroup: "franchiseGroup",
    }),
  },

  watch: {
    group() {
      this.drawer = false;
    },
  },

  methods: {
    ...mapMutations({
      setInfo: "SET_INFO",
      setFranchise: "SET_FRANCHISE",
      setFranchiseDate: "SET_FRANCHISE_DATE",
    }),

    logout: function() {
      this.$store.dispatch("_CLEAR_FRANCHISE");
      this.$store.dispatch("_LOGOUT");

      this.$router.push("/");
    },

    onLoading: function() {
      const localStorageItem = window.localStorage.getItem("gestor-food");
      if (localStorageItem) {
        this.setInfo();

        this.$router.push({
          name: "Home",
        });
      }

      const franchiseStorage = JSON.parse(
        window.localStorage.getItem("gestor-food-franchise")
      );

      if (franchiseStorage) {
        this.dialog.franchise = franchiseStorage;
        this.dialog.show = true;

        if (this.userSuper !== "S") {
          this.selectFranchise();
        }

        this.dialog.show = this.userSuper === "S";
      } else {
        this.logout();
      }
    },

    openFranchise() {
      this.$root.$emit("franchise-open-sidebar");
    },

    selectFranchise() {
      this.setFranchise(this.dialog.franchise);
      this.$root.$emit("reload-all-franchise-graphs", this.dialog.franchise.id);
      this.dialog.show = false;
    },

    toggleMenu(value = null) {
      if (value) {
        this.drawer = value;
        return;
      }

      this.drawer = !this.drawer;
    },
  },

  beforeCreate() {
    this.$nextTick(() => {
      this.onLoading();
    });
  },

  mounted() {
    this.$root.$on("show-exception-alert", (data) => {
      this.snackbar.text = data;
      this.snackbar.show = true;
    });

    this.$root.$on("reload-all-franchise-graphs", () => {
      this.date.value = this.franchiseDate;
    });
  },

  beforeDestroy() {
    this.$root.$off("show-exception-alert");
    this.$root.$off("reload-all-franchise-graphs");
  },
};
</script>
<style lang="css">
.v-application--wrap {
  padding-top: 50px;
}
</style>
